import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import ErrorView from '../../components/ErrorView'
import LoadingScreen from '../../components/LoadingScreen'
import PosDetailsView from './PosDetailsView'
import { POS_DETAILS_TEXTS } from './shared/posDetailsConstants'

const PosDetailsApp = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [isFetching, setIsFetching] = useState(true)
  const [details, setDetails] = useState(null)
  const [defaultDetails, setDefaultDetails] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchTransactionDetails()
  }, [])

  const fetchTransactionDetails = () => {
    setIsFetching(true)

    authFetch(`${BASE_BACKEND_URL}/pos_tasks/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (!response) {
          navigate('/')
          return null
        }
        if (response.status === 404) {
          return { error: true, message: POS_DETAILS_TEXTS.notFound }
        }
        return response.json()
      })
      .then((data) => {
        if (!data) {
          return
        }
        if (data.error) {
          setError(data.message)
        } else {
          setDetails(data)
          setDefaultDetails(data)
        }
      })
      .catch((e) => console.log(e))
      .finally(() => setIsFetching(false))
  }

  if (isFetching) {
    return <LoadingScreen text={POS_DETAILS_TEXTS.loading} />
  }

  return error ? <ErrorView error={error} /> : <PosDetailsView details={details} defaultDetails={defaultDetails} />
}

export default PosDetailsApp
